module.exports = __webpack_public_path__ + "img/zaag-.2d2c5cba.png";